export default __webpack_public_path__ + "static/media/gdi-logo.2a0bbf16.svg";